import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, withKeys as _withKeys, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67368911"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-dropdown-input" }
const _hoisted_2 = {
  key: 0,
  role: "listbox",
  class: "oxd-dropdown-options"
}
const _hoisted_3 = ["onMousedown"]
const _hoisted_4 = {
  key: 0,
  class: "oxd-dropdown-options-item --disabled"
}
const _hoisted_5 = {
  key: 0,
  class: "oxd-dropdown-selected"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_input = _resolveComponent("oxd-input")!
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_loading_spinner = _resolveComponent("oxd-loading-spinner")!
  const _component_oxd_chip = _resolveComponent("oxd-chip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "oxd-dropdown-container",
    onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)), ["esc"])),
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onSelectEnter && _ctx.onSelectEnter(...args)), ["prevent"]), ["enter"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onSelectDown && _ctx.onSelectDown(...args)), ["exact","prevent"]), ["down"])),
      _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onSelectUp && _ctx.onSelectUp(...args)), ["exact","prevent"]), ["up"]))
    ]
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_oxd_input, {
        hasError: _ctx.hasError,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        "onUpdate:modelValue": _ctx.onSearchUpdate,
        onClick: _ctx.toggleDropdown,
        onBlur: _ctx.onBlur,
        ref: "oxdInput"
      }, null, 8, ["hasError", "placeholder", "disabled", "onUpdate:modelValue", "onClick", "onBlur"]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({'oxd-dropdown-input-icon': true, '--disabled': _ctx.disabled})
          }, [
            (_ctx.selectedOptions.length != 0 && _ctx.clear && !_ctx.disabled)
              ? (_openBlock(), _createBlock(_component_oxd_icon, {
                  key: 0,
                  class: "--clear",
                  name: "x",
                  onClick: _ctx.onDropdownClear
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_oxd_icon, {
              class: "--arrow",
              name: _ctx.open ? 'caret-up-fill' : 'caret-down-fill',
              onClick: _ctx.toggleDropdown
            }, null, 8, ["name", "onClick"])
          ], 2))
        : (_openBlock(), _createBlock(_component_oxd_loading_spinner, {
            key: 1,
            class: "oxd-dropdown-input-loader",
            "with-container": false
          }))
    ]),
    _createVNode(_Transition, { name: "transition-fade-down" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (option, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  ref: `optElm-${index}`,
                  role: "option",
                  key: `${index}-options-${option.id}`,
                  class: _normalizeClass({
            'oxd-dropdown-options-item': true,
            '--disabled': option.disabled,
            '--selected': option.selected,
            '--focused': _ctx.isFocused(index),
            [`--indent-${option.indent}`]: true,
          }),
                  onMousedown: ($event: any) => (_ctx.onSelectOption(option))
                }, _toDisplayString(option.label), 43, _hoisted_3))
              }), 128)),
              (_ctx.filteredOptions.length === 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(_ctx.t('general.no_options', 'No options')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.multiple)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOptions, (option, index) => {
            return (_openBlock(), _createBlock(_component_oxd_chip, {
              key: `${index}-selected-${option.id}`,
              label: option.label,
              class: "oxd-dropdown-selected-chip"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_oxd_icon, {
                  class: _normalizeClass({'--clear': true, '--disabled': _ctx.disabled}),
                  name: "x",
                  onClick: ($event: any) => (_ctx.onRemoveOption(option))
                }, null, 8, ["class", "onClick"])
              ]),
              _: 2
            }, 1032, ["label"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 32))
}